module.exports = __webpack_public_path__ + "img/BRCA3_pDC.78c75a2e.png";